<template>
  <div :class="type === '1' ? 'donut-chart1' : 'donut-chart2'" >
    <div :class="type === '1' ? 'chart-container1' : 'chart-container2'">
      <highcharts :options="options"></highcharts>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);
export default {
  name: "DonutChart",
  components: { highcharts: Chart },
  props: {
    options: Object,
    type:String
  },
  data() {
   
    return {
    };
  },
};



</script>

<style scoped>
.chart-container1 {
  width: 100%;
  max-width: 350px;
  height: 100%;
  max-height: 350px;
  background-color: #fff;
}
@media (min-width: 1600px) {
  .chart-container1, .donut-chart1 {
    max-width: 450px;
  }
}
.donut-chart1 {
  width: 100%;
  max-width: 350px;
  height: 100%;
  max-height: 350px;
  overflow: hidden;
}
.chart-container2 {
  width: 100%;
  max-width: 350px;
  height: 100%;
  max-height: 320px;
  background-color: #fff;
}
.donut-chart2 {
  width: 100%;
  max-width: 350px;
  height: 100%;
  max-height: 320px;
  overflow: hidden;
}
</style>
